import { render, staticRenderFns } from "./EventList2.vue?vue&type=template&id=bd0d34ae&scoped=true&lang=pug"
import script from "./EventList2.vue?vue&type=script&lang=js"
export * from "./EventList2.vue?vue&type=script&lang=js"
import style0 from "./EventList2.vue?vue&type=style&index=0&id=bd0d34ae&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0d34ae",
  null
  
)

export default component.exports